import { FC } from 'react';
import styled from 'styled-components';

import { MenuType } from '#/service/constants/menu';

import { BannerManager } from './BannerManager';
import { HamburgerMenu } from './HamburgerMenu';
import { useHeader } from './Header.hook';
import { HeaderProps } from './Header.types';

const HeaderContainer = styled.header`
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  z-index: 101;

  /*
  Menu components and gradients are nested in tricky ways. In some cases, gradients can cover clickable elements.
  Making this container and its non-clickable children in both top & burger menus ignore pointer events to prevent this issue.
  */
  pointer-events: none;

  & a,
  & button,
  & img {
    pointer-events: auto;
  }
`;

export const Header: FC<HeaderProps> = ({
  menu,
  cacheKey,
  alwaysCollapsed = false,
  shouldShowUnauthenticatedHomePage = false,
  overrideMode,
}) => {
  const { Component, menuProps } = useHeader({
    menu,
    cacheKey,
    alwaysCollapsed,
    shouldShowUnauthenticatedHomePage,
    overrideMode,
  });

  return (
    <HeaderContainer data-testid="header">
      <BannerManager />
      {menu.type === MenuType.HAMBURGER ? (
        <HamburgerMenu {...menuProps} />
      ) : (
        <Component {...menuProps} />
      )}
    </HeaderContainer>
  );
};
